import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'

// CSS
import '../../css/sub-nav.css'

class AdminNav extends Component {
	constructor(props) {
		super(props)

		/* Explanation on access and admin roles:

			- Access is a string array of either 'admin' or 'manager' (currently). This coincides with the 'role' attribute in the "users" database table
			- This gives top-level access to the /admin routes. This is an array for if they want to add more than just managers later.
			
			- If you want the manager to have access to a sub component in a page, 
			  then give add 'manager' to the route here but restrict access on the page level.
			- Also for each section, give an an access to handle blocking entire sections.

		*/

		this.state = {
			sectionRoutes: [
				{
					title: 'Site',
					routes: [
						{
							title: 'Reviewers',
							path: '/admin/reviewers',
							matches: ['/admin/reviewers', '/admin/reviewers/add', '/admin/reviewers/edit'],
							exact: false,
							access: ['admin', 'manager'],
						},
						{
							title: 'Reviews',
							path: '/admin/reviews',
							matches: ['/admin/reviews', '/admin/reviews/add', '/admin/reviews/edit'],
							exact: false,
							access: ['admin', 'manager'],
						},
						{
							title: 'Reviews - Mass Email',
							path: '/admin/mass-email',
							matches: ['/admin/mass-email'],
							exact: true,
							access: ['admin'],
						},
						// {
						// 	title: "Reviews - Auto Notice Email",
						// 	path: "/admin/auto-notice-email",
						// 	matches: [
						// 		"/admin/auto-notice-email"
						// 	],
						// 	exact: true,
						// 	access: ['admin'],
						// },
						{
							title: 'Registered Reviewers',
							path: '/admin/registered',
							matches: ['/admin/registered'],
							exact: false,
							access: ['admin'],
						},
						{
							title: 'Organizations',
							path: '/admin/organizations',
							matches: [
								'/admin/organizations',
								'/admin/organizations/add',
								'/admin/organizations/edit',
							],
							exact: false,
							access: ['admin', 'manager'],
						},
						{
							title: 'Specialists',
							path: '/admin/specialists',
							matches: ['/admin/specialists'],
							exact: true,
							access: ['admin'],
						},
						{
							title: 'Banners',
							path: '/admin/banners',
							exact: true,
							access: ['admin'],
						},
						{
							title: 'FAQ',
							path: '/admin/faq',
							exact: false,
							access: ['admin'],
						},
						{
							title: 'News',
							path: '/admin/news',
							matches: ['/admin/news', '/admin/news/add', '/admin/news/edit'],
							exact: false,
							access: ['admin'],
						},
					],
					access: ['admin', 'manager'],
				},
				{
					title: 'Translations',
					routes: [
						{ title: 'Content Pages', path: '/admin/pages', exact: false, access: ['admin'] },
						{
							title: 'Application Sections',
							path: '/admin/translations',
							exact: false,
							access: ['admin'],
						},
					],
					access: ['admin'],
				},
				{
					title: 'Training',
					routes: [
						{
							title: 'Documents for Reviewers',
							path: '/admin/training-documents',
							matches: ['/admin/training-documents'],
							exact: true,
							access: ['admin', 'manager'],
						},
						{
							title: 'Training Education',
							path: '/admin/training-education',
							matches: ['/admin/training-education'],
							exact: true,
							access: ['admin', 'manager'],
						},
						{
							title: 'Training Surveys',
							path: '/admin/training-surveys',
							matches: ['/admin/training-surveys'],
							exact: true,
							access: ['admin', 'manager'],
						},
						{
							title: 'Training Video Surveys',
							path: '/admin/training-video-surveys',
							matches: ['/admin/training-video-surveys'],
							exact: true,
							access: ['admin', 'manager'],
						},
					],
					access: ['admin', 'manager'],
				},
				{
					title: 'User',
					routes: [
						{ title: 'Logout', path: '/admin/logout', exact: true, access: ['admin', 'manager'] },
					],
					access: ['admin', 'manager'],
				},
			],
			openSections: [],
		}
	}

	componentWillReceiveProps(nextProps) {
		// If the path is the same, do nothing
		if (!nextProps.route.path || this.props.route.path === nextProps.route.path) return

		const openSections = []

		// Loop over routes to see if the active route needs to be added to openSections
		this.state.sectionRoutes.map(section => {
			let result = null

			// Store any route matches
			result = section.routes.filter(route => {
				let routeResults = []

				// If there is an array of possible matches, let's see if one of them does indeed match
				if (route.matches) {
					routeResults = route.matches.filter(match => {
						// Is the possible route the same as the current route?
						return match === nextProps.route.path ? true : false
					})
				}
				// Only one possible route match, so we will just toss the result into an array since we are returning length below
				else {
					routeResults = route.path === nextProps.route.path ? [route] : []
				}

				// If there are matches found, then this array will have entries.
				// If this is true, this route will pass the filter test
				return routeResults.length
			})

			// If there is a match found within this route, it's gonna be open!
			if (result.length) {
				// If the path title is already in openSections, do nothing
				if (this.state.openSections.indexOf(section.title) > -1) return null

				openSections.push(section.title)
			}

			return null
		})

		// Finally, add the section title to openSections
		this.setState(
			{
				openSections,
			},
			() => {
				// If there are no open sections, open all of them!
				if (!this.state.openSections.length) {
					this.setState({
						openSections: [...this.state.sectionRoutes.map(section => section.title)],
					})
				}
			}
		)
	}

	handleSectionClick = sectionTitle => {
		const titleIndex = this.state.openSections.indexOf(sectionTitle)

		// console.log(this.state.openSections)

		if (titleIndex > -1) {
			this.setState({
				openSections: this.state.openSections.filter((title, i) => i !== titleIndex),
			})
		} else {
			this.setState({ openSections: [...this.state.openSections, sectionTitle] })
		}
	}

	isSectionOpen = section => {
		// Determine if this section is in the openSections collection (array of titles)
		const result = this.state.openSections.filter(openSection => {
			return openSection === section.title
		})

		return result.length
	}

	render() {
		const { role } = this.props.user

		return (
			<div className='sub_nav'>
				<div className='stick-to-top'>
					<div className='title'>{role === 'admin' ? 'Admin Menu' : 'Manager Menu'}</div>

					<nav>
						{this.state.sectionRoutes.map(
							section =>
								section.access.includes(role) && (
									<div key={section.title} className='nav_section'>
										<div
											className={'section_title' + (this.isSectionOpen(section) ? ' open' : '')}
											onClick={e => this.handleSectionClick(section.title)}
										>
											<span className='section_title--title'>{section.title}</span>
											<span className='icon-keyboard_arrow_right' />
										</div>
										<div>
											{section.routes.map(
												route =>
													route.access.includes(role) && (
														<NavLink
															key={route.title}
															activeClassName='active'
															to={route.path}
															exact={!!route.exact}
														>
															{route.title}
														</NavLink>
													)
											)}
										</div>
									</div>
								)
						)}
					</nav>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		route: state.route,
		user: state.user.admin.user,
	}
}

export default connect(mapStateToProps)(AdminNav)



// WEBPACK FOOTER //
// ./src/components/admin/AdminNav.js